import Button from "../../../custom/button/button";
import styles from "./paymentOptions.module.scss";
import classNames from "classnames";
import { useQuery } from "@tanstack/react-query";
import { getPaymentChannels } from "../../../requests";
import { Spin } from "antd";
import { AxiosError } from "axios";

const PaymentOptions = ({
  channel,
  setChannel,
  onOk,
  onCancel,
}: {
  channel: PaymentChannel;
  setChannel: (channel: string) => void;
  onOk: (method: string, url: string) => void;
  onCancel: () => void;
}) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["get-payment-channels"],
    queryFn: getPaymentChannels,
  });

  if (isLoading)
    return <Spin style={{ justifySelf: "center", alignSelf: "center" }} />;
  if (isError) return <div>{(error as AxiosError)?.message}</div>;

  const response = data?.Data as PaymentChannelOptions[];
  const paymentOptions = [
    ...response?.filter((x) => x.Name?.toLowerCase() === "cyberpay"),
    ...response?.filter((x) => x.Name?.toLowerCase() !== "cyberpay"),
  ] as PaymentChannelOptions[];

  const url =
    paymentOptions?.find((x) => x.Name?.toLowerCase() === "interswitch")
      ?.PaymentUrl || "";

  return (
    <div className={styles.content}>
      <h3 className={styles.heading}>Select Payment Option</h3>
      <div className={styles.container}>
        {paymentOptions &&
          paymentOptions?.length > 0 &&
          paymentOptions?.map((option) => {
            const isSelected = channel === option.Name;
            return (
              <div
                key={option.Name}
                className={classNames(
                  styles.option,
                  "spaceBetween",
                  isSelected ? styles.outline : ""
                )}
                onClick={() => setChannel(option.Name)}
              >
                <div className="flexWithGap">
                  {/* <CyberPay /> */}
                  <img
                    className={styles.optionImg}
                    src={option.ImageUrl}
                    alt={option.Name}
                  />
                  {/* <span>{option.Name}</span> */}
                </div>
                <input
                  name="channel"
                  type="radio"
                  value={option.Name}
                  checked={isSelected}
                  onChange={(e) => setChannel(e.target.value)}
                  width={24}
                  height={24}
                />
              </div>
            );
          })}
        <div className={styles.cta}>
          <Button
            type="button"
            className={styles.greyBtn}
            onClick={onCancel}
            text="Cancel"
          />
          <Button
            onClick={() => {
              onOk(channel, url);
            }}
            text="Confirm"
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentOptions;
